// extracted by mini-css-extract-plugin
module.exports = {"loadingLayer":"Chart_loadingLayer__3YafK","spinner":"Chart_spinner__37TJ2"};